<ng-container *ngIf="imageurl">
  <img *ngIf="imageurl" [src]="imageurl" alt="" />

  <span class="mat-display-2">
    {{ channel?.name }}
  </span>
</ng-container>
